import React from 'react';
import classNames from 'classnames';
import GlobalCtx from '@components/globalContext';

const Notice = (): JSX.Element => {
  const { app, setApp } = React.useContext(GlobalCtx);
  const { notice } = app;

  const wrapperClasses = classNames(
    'fixed w-full text-white text-center py-6 px-2 shadow-lg z-10 left-0',
    {
      'bg-red-600': notice.type === 'ERROR',
      'bg-orange-600': notice.type === 'WARNING',
    },
  );

  const hide = () => {
    setApp({
      ...app,
      notice: {
        ...app.notice,
        isVisible: false,
      },
    });
  };
  if (!notice.isVisible) {
    return null;
  }

  return (
    <section className={wrapperClasses}>
      <p className="text-xl">{notice?.message || 'Unknown Error'}</p>
      <a
        href="#"
        onClick={hide}
        title="Close"
        className="no-underline hover:bg-white/20 w-6 h-6 text-center right-0 top-0 absolute rounded-full m-2"
      >
        X
      </a>
    </section>
  );
};

export default Notice;
